import { ref, onMounted } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-8bb4e44e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "ios-refund-evidence-page"
};
import { queryIosRefundEvidenceList } from '@/api/orderApi';
import EvidenceTable from './components/EvidenceTable.vue';
import SearchPanel from './components/SearchPanel.vue';
import { OK, reportEvent } from '@/common';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const loading = ref(false);
    const pageNum = ref(1);
    const pageSize = ref(20);
    const total = ref(0);
    const dataSource = ref([]);
    const searchParams = ref({});
    const removeEmptyParams = params => {
      return Object.fromEntries(Object.entries(params).filter(([, value]) => {
        return !(value === '' || value === null || value === undefined || Array.isArray(value) && value.length === 0);
      }));
    };
    const getList = async () => {
      loading.value = true;
      try {
        const params = removeEmptyParams({
          pageNum: pageNum.value,
          pageSize: pageSize.value,
          ...searchParams.value
        });
        const {
          code,
          data
        } = await queryIosRefundEvidenceList(params);
        if (code === OK) {
          dataSource.value = (data === null || data === void 0 ? void 0 : data.list) || [];
          total.value = (data === null || data === void 0 ? void 0 : data.total) || 0;
          return 'succeed';
        }
        return 'failed';
      } catch (error) {
        dataSource.value = [];
        total.value = 0;
        return 'failed';
      } finally {
        loading.value = false;
      }
    };
    const getListBySearch = async () => {
      const startTime = Date.now();
      const status = await getList();
      const duration = Date.now() - startTime;
      reportEvent({
        eventName: '_search',
        properties: {
          ui_name: 'ios退款举证',
          app_name: '',
          return_duration: duration / 1000,
          query_status: status
        }
      });
    };
    const handleSearch = payload => {
      pageNum.value = 1;
      searchParams.value = payload;
      getListBySearch();
    };
    const handlePageChange = (page, size) => {
      pageNum.value = page;
      pageSize.value = size;
      getList();
    };
    onMounted(() => {
      getList();
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(SearchPanel, {
        loading: loading.value,
        onSearch: handleSearch
      }, null, 8, ["loading"]), _createVNode(EvidenceTable, {
        class: "evidence-table-panel",
        loading: loading.value,
        "data-source": dataSource.value,
        "page-num": pageNum.value,
        "page-size": pageSize.value,
        total: total.value,
        onPageChange: handlePageChange
      }, null, 8, ["loading", "data-source", "page-num", "page-size", "total"])]);
    };
  }
});